import { render, staticRenderFns } from "./ArrowRight.vue?vue&type=template&id=fff0c23a&"
import script from "./ArrowRight.vue?vue&type=script&lang=js&"
export * from "./ArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports